
import Vue, { PropType } from 'vue';
import Modal from '@/components/modal/Modal.vue';
import { LuminaireRow } from '@/interfaces/luminaires';

export default Vue.extend({
	components: {
		Modal,
	},
	props: {
		unassignableDevice: { type: Object as PropType<LuminaireRow> },
		zoneName: String,
	},

	methods: {
		closeModal(): void {
			this.$bvModal.hide('modal-unassign-device');
		},

		confirmModal(): void {
			this.$emit('unassignDevice', this.unassignableDevice.id);
		},

		reset(): void {
			this.$emit('reset');
		},
	},
});
